import { useCompany } from './useCompany';
import type { EarlySignalsConfig, EarlySignalsTabsConfig } from '../types';

const DEFAULT_TABS: EarlySignalsTabsConfig = {
  ai: true,
  dashboard: true,
  intelligence: false,
  alerts: false,
  riskMatrix: true,
  riskDial: true,
  mitigation: true,
  specialReports: true,
  executiveSummary: true,
  categoryAi: false,
  supplierRiskIntake: false,
  sendRiskAlert: false,
  riskAlerts: true,
  briefs: false,
};

export function useEarlySignalsConfig(): {
  config: EarlySignalsConfig | null;
  tabs: EarlySignalsTabsConfig;
  isTabEnabled: (tabId: string) => boolean;
} {
  const { settings } = useCompany();
  const customizations = settings?.customizations ?? {};
  const earlySignals = (customizations.earlySignals ?? {}) as EarlySignalsConfig;
  const tabs: EarlySignalsTabsConfig = { ...DEFAULT_TABS, ...earlySignals.tabs };

  const isTabEnabled = (tabId: string): boolean => {
    const key = tabId as keyof EarlySignalsTabsConfig;
    return tabs[key] !== false;
  };

  return {
    config: Object.keys(earlySignals).length ? earlySignals : null,
    tabs,
    isTabEnabled,
  };
}
